import onResize from '../actions/onResize';
import getScenarioStore from '../store/getScenarioStore';
import { observer } from 'mobx-react';
import { Callout } from 'office-ui-fabric-react/lib/Callout';
import { getGuid } from 'owa-guid';
import { SEARCHBOX_ANCHOR_ID, SearchScenarioId } from 'owa-search-next-common';
import * as React from 'react';

export interface SearchBoxDropdownProps {
    content: JSX.Element | JSX.Element[];
    id?: string;
    onDismiss?: (evt: any) => void;
    onPositioned?: () => void;
    role?: string;
    scenarioId: SearchScenarioId;
    setInitialFocus: boolean;
    targetId?: string;
}

@observer
export default class SearchBoxDropdown extends React.Component<SearchBoxDropdownProps, {}> {
    render() {
        const { content, scenarioId, id = getGuid(), setInitialFocus } = this.props;

        return (
            <Callout
                calloutWidth={this.getWidth(scenarioId)}
                id={id}
                onDismiss={this.onDismiss}
                onPositioned={this.onPositioned}
                setInitialFocus={setInitialFocus}
                gapSpace={1}
                isBeakVisible={false}
                target={`#${this.getTargetId()}`}>
                {content}
            </Callout>
        );
    }

    /**
     * Update component width once it mounts. This will ensure that the component
     * has the same width as the search box.
     */
    componentDidMount() {
        onResize(this.props.scenarioId, document.getElementById(this.getTargetId()).offsetWidth);
    }

    /**
     * Gets the known width of the search box by checking the store value, or
     * directly accessing the element if the store value hasn't yet been
     * updated.
     */
    private getWidth(scenarioId: SearchScenarioId): number {
        return (
            getScenarioStore(scenarioId).searchBoxWidth ||
            document.getElementById(this.getTargetId()).offsetWidth
        );
    }

    /**
     * onDismiss callback for the Callout component.
     */
    private onDismiss = (evt: React.MouseEvent<unknown>): void => {
        const { onDismiss } = this.props;

        if (onDismiss) {
            onDismiss(evt);
        }
    };

    /**
     * Gets target ID of which component is mounting on. It's an optional prop,
     * so a default case is set to the anchor div in the SearchBox component.
     */
    private getTargetId(): string {
        return this.props.targetId || SEARCHBOX_ANCHOR_ID;
    }

    /**
     * Callback for when the Callout gets correctly positioned.
     */
    private onPositioned = (): void => {
        if (this.props.onPositioned) {
            this.props.onPositioned();
        }
    };
}
